import React from 'react'
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./mainslider.css"

import slider5 from "../../images/slider5.jpg"
import slider6 from "../../images/slider6.jpg"
import slider7 from "../../images/slider7.jpg"
import slider8 from "../../images/slider8.jpg"



function Mainslider() {

    const spark = (e) => {
        let i = document.createElement("i");
        
        // Set the position of the spark
        i.style.left = `${e.pageX}px`;
        i.style.top = `${e.pageY}px`;
    
        // Randomly scale the spark
        i.style.scale = `${Math.random() * 1 + 0.8}`;
    
        // Set random colors
        const colors = ['red', 'green', 'blue', 'yellow', 'purple', 'cyan'];
        const randomColor = colors[Math.floor(Math.random() * colors.length)];
        i.style.backgroundColor = randomColor;
    
        // Set random transition values
        i.style.setProperty('--x', getTransitionValue());
        i.style.setProperty('--y', getTransitionValue());
        
        // Append the spark element to the body
        document.body.appendChild(i);
    
        // Remove the spark element after 2 seconds
        setTimeout(() => {
            document.body.removeChild(i);
        }, 2000);
    }
    
    const getTransitionValue = () => {
        return `${Math.random() * 400 - 200}px`
    }
    
    document.addEventListener("mousemove", spark);
    


    var settings = {
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <>


            <Slider {...settings}>
                <div className='slidermaindiv'>
                    <img src={slider5} className='sliderimg' alt="sliderimg" />
                </div>
                <div className='slidermaindiv'>
                    <img src={slider6} className='sliderimg' alt="sliderimg" />
                </div>
                <div className='slidermaindiv'>
                    <img src={slider7} className='sliderimg' alt="sliderimg" />
                </div>
                <div className='slidermaindiv'>
                    <img src={slider8} className='sliderimg' alt="sliderimg" />
                </div>
            </Slider>
            
        
        </>
    )
}

export default Mainslider
